import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/warehouse-management/quantity-inventory-of-waste-warehouse`;

export const quantityInventoryOfWasteWarehouseRoutesObj = {
  list: baseRoute,
  viewItemInventory: `${baseRoute}/view-item-inventory/:productId/:warehouseId`,
  warehouseExit: `${baseRoute}/warehouse-exit/:productId/:warehouseId/:previousWarehouseId`,
  returnFromScrapWarehouse: `${baseRoute}/return-from-scrap-warehouse/:productId/:warehouseId`,
} as const;

export type IQuantityInventoryOfWasteWarehouseRouteParams =
  IExtractRouteParamMap<typeof quantityInventoryOfWasteWarehouseRoutesObj>;

export const quantityInventoryOfWasteWarehousePath = createPaths<
  typeof quantityInventoryOfWasteWarehouseRoutesObj,
  IQuantityInventoryOfWasteWarehouseRouteParams
>(quantityInventoryOfWasteWarehouseRoutesObj);
